import type {
  StorefrontLinkCreateRequestType,
  StorefrontLinkCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontLinkCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: StorefrontLinkCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `storefront-link`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as StorefrontLinkCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontLink],
      });
    },
  });
};
